export const GET_UI_REQUEST = "GET_UI_REQUEST"
export const GET_UI_SUCCESS = "GET_UI_SUCCESS"
export const GET_UI_FAILED = "GET_UI_FAILED"

export const GetCUserInfo = (appwebId:String)=>{
    return{
        type:GET_UI_REQUEST,payload: { appwebId}
    }
}
